<template>
  <div class="pa-4 text-center">
    <v-dialog v-model="isShown" max-width="600" persistent       transition="dialog-bottom-transition"
    :fullscreen="fullscreen">
      <v-card>
         <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="cancel()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        <v-card-title>{{ title }}</v-card-title>
         </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="py-10">
          <slot />
        </v-card-text>
        <v-divider></v-divider>
    
      </v-card>
    </v-dialog></div>
</template>

<script>
export default {
  props: {
    width: {
      default: "550px",
    },
     isShown: {
      type: Boolean,
      default: false,
    }, 
    fullscreen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },  
  
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>